/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/textpattern/TextPatternScannerScreenTextLocalization.yaml

import type { DeepPartial } from '../../utils/utils';
import { PartiallyConstructible } from '../../utils/utils';

/**
Configuration of the all strings for generic text scanner screen.
*/
export class TextPatternScannerScreenTextLocalization extends PartiallyConstructible {
  /**
    Title for the top bar.
    
    Default is "Text Scanner"
    */
  public topBarTitle = 'Text Scanner';
  /**
    Cancel button text for the top bar.
    
    Default is "Cancel"
    */
  public topBarCancelButton = 'Cancel';
  /**
    Text for the top user guidance caption.
    
    Default is "Locate the text you are looking for"
    */
  public topUserGuidance = 'Locate the text you are looking for';
  /**
    Text for the user guidance caption below the finder view.
    
    Default is "Scanning for text pattern..."
    */
  public finderViewUserGuidance = 'Scanning for text pattern...';
  /**
    Title for the introduction screen.
    
    Default is "How to scan text"
    */
  public introScreenTitle = 'How to scan text';
  /**
    Start scanning button text for the introduction screen.
    
    Default is "Start Scanning"
    */
  public introScreenDoneButton = 'Start Scanning';
  /**
    The text explanation for the introduction screen.
    
    Default is "To scan a single line of text, please hold your device so that the camera viewfinder clearly captures the text you want to scan. Please ensure the text is properly aligned. Once the scan is complete, the text will be automatically extracted.\n\nPress 'Start Scanning' to begin."
    */
  public introScreenText =
    "To scan a single line of text, please hold your device so that the camera viewfinder clearly captures the text you want to scan. Please ensure the text is properly aligned. Once the scan is complete, the text will be automatically extracted.\n\nPress 'Start Scanning' to begin.";
  /**
    Caption for the success overlay.
    
    Default is "Scanned successfully"
    */
  public completionOverlaySuccessMessage = 'Scanned successfully';
  /**
    Accessibility description for the 'open introduction screen' button in top bar.
    
    Default is "Open introduction screen."
    */
  public accessibilityDescriptionOpenIntroScreenButton = 'Open introduction screen.';
  /**
    Accessibility description for the 'done'/'start scanning' button in the introduction screen.
    
    Default is "Start scanning"
    */
  public accessibilityDescriptionIntroScreenDoneButton = 'Start scanning';
  /**
    Accessibility description for the 'cancel' button in the top bar.
    
    Default is "Cancel"
    */
  public accessibilityDescriptionCancelButton = 'Cancel';
  /**
    Title for the text pattern confirmation alert.
    
    Default is "Text Detected!"
    */
  public textPatternConfirmationAlertTitle = 'Text Detected!';
  /**
    Cancel button text for the text pattern confirmation alert.
    
    Default is "Retry"
    */
  public textPatternConfirmationAlertCancelButton = 'Retry';
  /**
    Submit button text for the text pattern confirmation alert.
    
    Default is "Submit"
    */
  public textPatternConfirmationAlertSubmitButton = 'Submit';
  /**
    Accessibility description for the cancel button in the text pattern confirmation alert.
    
    Default is "Retry"
    */
  public accessibilityDescriptionConfirmationCancelButton = 'Retry';
  /**
    Accessibility description for the submit button in the text pattern confirmation alert.
    
    Default is "Submit"
    */
  public accessibilityDescriptionConfirmationSubmitButton = 'Submit';
  /**
    Accessibility description for the flash button.
    
    Default is "Toggle flash"
    */
  public accessibilityDescriptionFlashButton = 'Toggle flash';
  /**
    Accessibility description for the zoom button.
    
    Default is "Toggle camera zoom"
    */
  public accessibilityDescriptionZoomButton = 'Toggle camera zoom';
  /**
    Accessibility description for the flip camera button.
    
    Default is "Flip camera"
    */
  public accessibilityDescriptionFlipCameraButton = 'Flip camera';
  /**
    The title of the camera permission dialog.
    
    Default is "Camera permission denied!"
    */
  public cameraPermissionEnableCameraTitle = 'Camera permission denied!';
  /**
    The explanation text of the camera permission dialog.
    
    Default is "Please allow the usage of the camera to start the scanning process."
    */
  public cameraPermissionEnableCameraExplanation =
    'Please allow the usage of the camera to start the scanning process.';
  /**
    The 'enable' button title of the camera permission dialog.
    
    Default is "Grant permission"
    */
  public cameraPermissionEnableCameraButton = 'Grant permission';
  /**
    The 'close' button title of the camera permission dialog.
    
    Default is "Close"
    */
  public cameraPermissionCloseButton = 'Close';
  /**
    The accessibility hint for the 'enable' button of the camera permission dialog.
    
    Default is "Tap to grant camera permission"
    */
  public accessibilityDescriptionCameraPermissionEnableCameraButton = 'Tap to grant camera permission';
  /**
    The accessibility hint for the 'close' button of the camera permission dialog.
    
    Default is "Close screen without granting permission"
    */
  public accessibilityDescriptionCameraPermissionCloseButton = 'Close screen without granting permission';

  /** @param source {@displayType `DeepPartial<TextPatternScannerScreenTextLocalization>`} */
  public constructor(source: DeepPartial<TextPatternScannerScreenTextLocalization> = {}) {
    super();
    if (source.topBarTitle !== undefined) {
      this.topBarTitle = source.topBarTitle;
    }
    if (source.topBarCancelButton !== undefined) {
      this.topBarCancelButton = source.topBarCancelButton;
    }
    if (source.topUserGuidance !== undefined) {
      this.topUserGuidance = source.topUserGuidance;
    }
    if (source.finderViewUserGuidance !== undefined) {
      this.finderViewUserGuidance = source.finderViewUserGuidance;
    }
    if (source.introScreenTitle !== undefined) {
      this.introScreenTitle = source.introScreenTitle;
    }
    if (source.introScreenDoneButton !== undefined) {
      this.introScreenDoneButton = source.introScreenDoneButton;
    }
    if (source.introScreenText !== undefined) {
      this.introScreenText = source.introScreenText;
    }
    if (source.completionOverlaySuccessMessage !== undefined) {
      this.completionOverlaySuccessMessage = source.completionOverlaySuccessMessage;
    }
    if (source.accessibilityDescriptionOpenIntroScreenButton !== undefined) {
      this.accessibilityDescriptionOpenIntroScreenButton = source.accessibilityDescriptionOpenIntroScreenButton;
    }
    if (source.accessibilityDescriptionIntroScreenDoneButton !== undefined) {
      this.accessibilityDescriptionIntroScreenDoneButton = source.accessibilityDescriptionIntroScreenDoneButton;
    }
    if (source.accessibilityDescriptionCancelButton !== undefined) {
      this.accessibilityDescriptionCancelButton = source.accessibilityDescriptionCancelButton;
    }
    if (source.textPatternConfirmationAlertTitle !== undefined) {
      this.textPatternConfirmationAlertTitle = source.textPatternConfirmationAlertTitle;
    }
    if (source.textPatternConfirmationAlertCancelButton !== undefined) {
      this.textPatternConfirmationAlertCancelButton = source.textPatternConfirmationAlertCancelButton;
    }
    if (source.textPatternConfirmationAlertSubmitButton !== undefined) {
      this.textPatternConfirmationAlertSubmitButton = source.textPatternConfirmationAlertSubmitButton;
    }
    if (source.accessibilityDescriptionConfirmationCancelButton !== undefined) {
      this.accessibilityDescriptionConfirmationCancelButton = source.accessibilityDescriptionConfirmationCancelButton;
    }
    if (source.accessibilityDescriptionConfirmationSubmitButton !== undefined) {
      this.accessibilityDescriptionConfirmationSubmitButton = source.accessibilityDescriptionConfirmationSubmitButton;
    }
    if (source.accessibilityDescriptionFlashButton !== undefined) {
      this.accessibilityDescriptionFlashButton = source.accessibilityDescriptionFlashButton;
    }
    if (source.accessibilityDescriptionZoomButton !== undefined) {
      this.accessibilityDescriptionZoomButton = source.accessibilityDescriptionZoomButton;
    }
    if (source.accessibilityDescriptionFlipCameraButton !== undefined) {
      this.accessibilityDescriptionFlipCameraButton = source.accessibilityDescriptionFlipCameraButton;
    }
    if (source.cameraPermissionEnableCameraTitle !== undefined) {
      this.cameraPermissionEnableCameraTitle = source.cameraPermissionEnableCameraTitle;
    }
    if (source.cameraPermissionEnableCameraExplanation !== undefined) {
      this.cameraPermissionEnableCameraExplanation = source.cameraPermissionEnableCameraExplanation;
    }
    if (source.cameraPermissionEnableCameraButton !== undefined) {
      this.cameraPermissionEnableCameraButton = source.cameraPermissionEnableCameraButton;
    }
    if (source.cameraPermissionCloseButton !== undefined) {
      this.cameraPermissionCloseButton = source.cameraPermissionCloseButton;
    }
    if (source.accessibilityDescriptionCameraPermissionEnableCameraButton !== undefined) {
      this.accessibilityDescriptionCameraPermissionEnableCameraButton =
        source.accessibilityDescriptionCameraPermissionEnableCameraButton;
    }
    if (source.accessibilityDescriptionCameraPermissionCloseButton !== undefined) {
      this.accessibilityDescriptionCameraPermissionCloseButton =
        source.accessibilityDescriptionCameraPermissionCloseButton;
    }
  }
}
